module.exports = __webpack_public_path__ + "media/images/icons/SVG/015-8398cee189e376ebeea10e01f622914b.svg";